export var TripAccessCode;
(function (TripAccessCode) {
    TripAccessCode["INVITE"] = "invite-only";
    TripAccessCode["PUBLIC"] = "public";
    TripAccessCode["APPROVAL"] = "approval";
})(TripAccessCode || (TripAccessCode = {}));
